

















































































































































































































































































































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { Dashboard } from '@/api/model/dashboard'
import { User } from '@/api/model/user'
import { Branch } from '@/api/model/branch'
import { CumulioAPI, CumulioQuery, CumulioResult } from '@/api/client/cumulio'
import { CompanyTargetType } from '@/api/types'
import { DateRange } from '@/components/input/InputDateRange.vue'
import AchievedBarChart, { AchievedBarChartData } from '@/views/Reports/Report/SalesReport/AchievedBarChart.vue'
import AchievedDoughnutChart, { AchievedDoughnutChartData } from '@/views/Reports/Report/SalesReport/AchievedDoughnutChart.vue'
import PerSubjectTable, { PerSubjectTableData } from '@/views/Reports/Report/SalesReport/PerSubjectTable.vue'
import PerSubjectOverviewTable, { PerSubjectOverviewTableData } from '@/views/Reports/Report/SalesReport/PerSubjectOverviewTable.vue'
import PerSubjectPieChart, { PerSubjectPieChartData } from '@/views/Reports/Report/SalesReport/PerSubjectPieChart.vue'
import SalesReportMixin from '@/views/Reports/Report/SalesReport/SalesReportMixin'
import InformationPopup from '@/views/Reports/Report/SalesReport/InformationPopup.vue'
import QuantityPerMonthInformation from '@/views/Reports/Report/SalesReport/InformationPopup/QuantityPerMonthInformation.vue'
import QuantityCurrentYearInformation from '@/views/Reports/Report/SalesReport/InformationPopup/QuantityCurrentYearInformation.vue'
import QuantityPerUserCurrentYearInformation from '@/views/Reports/Report/SalesReport/InformationPopup/QuantityPerUserCurrentYearInformation.vue'
import TurnoverPerMonthInformation from '@/views/Reports/Report/SalesReport/InformationPopup/TurnoverPerMonthInformation.vue'
import TurnoverCurrentYearInformation from '@/views/Reports/Report/SalesReport/InformationPopup/TurnoverCurrentYearInformation.vue'
import TurnoverPerUserCurrentYearInformation from '@/views/Reports/Report/SalesReport/InformationPopup/TurnoverPerUserCurrentYearInformation.vue'
import TurnoverPercentagePerUserCurrentYearInformation from '@/views/Reports/Report/SalesReport/InformationPopup/TurnoverPercentagePerUserCurrentYearInformation.vue'
import TurnoverPercentagePerBranchCurrentYearInformation from '@/views/Reports/Report/SalesReport/InformationPopup/TurnoverPercentagePerBranchCurrentYearInformation.vue'
import OverviewPerUserInformation from '@/views/Reports/Report/SalesReport/InformationPopup/OverviewPerUserInformation.vue'
import OverviewPerBranchInformation from '@/views/Reports/Report/SalesReport/InformationPopup/OverviewPerBranchInformation.vue'
import moment from 'moment-timezone'

interface PerMonthData {
    [month: string]: {
        quantity: number,
        achievedQuantity: number,
        turnover: number,
        achievedTurnover: number,
    }
}

interface PerSubjectData {
    [subjectId: string]: {
        subject: User|Branch,
        achievedQuantity: number,
        involvedQuantity: number,
        achievedTurnover: number,
    }
}

@Component({
    components: {
        AchievedBarChart,
        AchievedDoughnutChart,
        PerSubjectTable,
        PerSubjectOverviewTable,
        PerSubjectPieChart,
        InformationPopup,
        QuantityPerMonthInformation,
        QuantityCurrentYearInformation,
        QuantityPerUserCurrentYearInformation,
        TurnoverPerMonthInformation,
        TurnoverCurrentYearInformation,
        TurnoverPerUserCurrentYearInformation,
        TurnoverPercentagePerUserCurrentYearInformation,
        TurnoverPercentagePerBranchCurrentYearInformation,
        OverviewPerBranchInformation,
        OverviewPerUserInformation,
    },
})
export default class SalesReport extends Mixins(SalesReportMixin) {
    @Prop({ required: true }) readonly dashboard!: Dashboard
    showFilters: boolean = false
    period: DateRange = {
        fromDate: moment().startOf('year').toDate(),
        untilDate: moment().endOf('year').toDate(),
    }
    branch: Branch = null
    user: User = null
    loading: boolean = false
    loadingSalesPerMonthData: boolean = false
    salesPerMonthData: PerMonthData = {}
    loadingMortgagePerMonthData: boolean = false
    mortgagePerMonthData: PerMonthData = {}
    loadingSalesPerUserData: boolean = false
    salesPerUserData: PerSubjectData = {}
    loadingMortgagePerUserData: boolean = false
    mortgagePerUserData: PerSubjectData = {}
    loadingSalesPerBranchData: boolean = false
    salesPerBranchData: PerSubjectData = {}
    loadingMortgagePerBranchData: boolean = false
    mortgagePerBranchData: PerSubjectData = {}

    async mounted() {
        await this.loadData()
    }

    toggleFilters(): void {
        this.showFilters = !this.showFilters
    }

    get availableBranches(): Branch[] {
        return this.$currentCompany.getAvailableBranches()
    }

    get availableUsers(): User[] {
        return this.$currentCompany.getAvailableUsers({ branch: this.branch })
    }

    get fromDate(): moment.Moment {
        return moment(this.period.fromDate)
    }

    get untilDate(): moment.Moment {
        return moment(this.period.untilDate)
    }

    async loadData(): Promise<void> {
        this.loading = true

        await Promise.all([
            this.loadSalesPerMonthData(),
            this.loadMortgagePerMonthData(),
            this.loadSalesPerUserData(),
            this.loadMortgagePerUserData(),
            this.loadSalesPerBranchData(),
            this.loadMortgagePerBranchData(),
        ])

        this.loading = false
    }

    @Watch('period')
    @Watch('user')
    @Watch('branch')
    async loadSalesPerMonthData(): Promise<void> {
        this.loadingSalesPerMonthData = true
        this.salesPerMonthData = await this.loadPerMonthData('sale')
        this.loadingSalesPerMonthData = false
    }

    @Watch('period')
    @Watch('user')
    @Watch('branch')
    async loadMortgagePerMonthData(): Promise<void> {
        this.loadingMortgagePerMonthData = true
        this.mortgagePerMonthData = await this.loadPerMonthData('mortgage')
        this.loadingMortgagePerMonthData = false
    }

    async loadPerMonthData(type: string): Promise<PerMonthData> {
        const perMonthData = this.initPerMonthData()

        // Load achieved quantity
        const achievedQuantityData = await this.loadAchievedQuantityPerMonthData(type)
        for (const data of achievedQuantityData) {
            const date = moment(data.date)
            perMonthData[date.format('YYYY-MM')].achievedQuantity = parseFloat(data.quantity as string)
        }

        // Load achieved turnover
        const achievedTurnoverData = await this.loadAchievedTurnoverPerMonthData(type)
        for (const data of achievedTurnoverData) {
            const date = moment(data.date)
            perMonthData[date.format('YYYY-MM')].achievedTurnover = parseFloat(data.turnover as string)
        }

        // Load targets
        const achievedTargetsData = await this.loadAchievedTargetsData(type)
        for (const data of achievedTargetsData) {
            const date = moment(data.date)
            perMonthData[date.format('YYYY-MM')].quantity = parseFloat(data.quantity as string)
            perMonthData[date.format('YYYY-MM')].turnover = parseFloat(data.turnover as string)
        }

        return perMonthData
    }

    initPerMonthData(): PerMonthData {
        const perMonthData: PerMonthData = {}

        const date = moment(this.fromDate)
        while (date.isBefore(this.untilDate)) {
            perMonthData[date.format('YYYY-MM')] = {
                quantity: null,
                achievedQuantity: null,
                turnover: null,
                achievedTurnover: null,
            }

            date.add('1', 'month')
        }

        return perMonthData
    }

    async loadAchievedQuantityPerMonthData(type: string): Promise<CumulioResult[]> {
        const query = this.initQuery('achieved_quantity', type)
        query.addColumn('date', { level: 'month' })
        query.addColumn('quantity', { aggregation: 'sum' })
        query.addFilter('direction', '=', this.directionForType(type))

        if (this.branch) {
            query.addFilter('team_id', '=', this.branch.id)
        }

        if (this.user) {
            query.addFilter('user_id', '=', this.user.id)
        }

        return await CumulioAPI.query(query)
    }

    async loadAchievedTurnoverPerMonthData(type: string): Promise<CumulioResult[]> {
        const query = this.initQuery('achieved_turnover', type)
        query.addColumn('date', { level: 'month' })
        query.addColumn('turnover', { aggregation: 'sum' })

        if (this.branch) {
            query.addFilter('team_id', '=', this.branch.id)
        }

        if (this.user) {
            query.addFilter('user_id', '=', this.user.id)
        }

        return await CumulioAPI.query(query)
    }

    async loadAchievedTargetsData(type: string): Promise<CumulioResult[]> {
        let query

        if (this.$currentCompany.targetType === CompanyTargetType.TEAM) {
            query = this.initQuery('team_targets', type, 'team_id', '')

            if (this.branch) {
                query.addFilter('team_id', '=', this.branch.id)
            }

            if (this.user) {
                return [] // when using team targets, we cannot determine the targets for a specific user
            }
        }

        if (this.$currentCompany.targetType === CompanyTargetType.USER) {
            query = this.initQuery('user_targets', type, '', 'user_id')

            if (this.branch) {
                return [] // when using user targets, we cannot determine the targets for a specific team
            }

            if (this.user) {
                query.addFilter('user_id', '=', this.user.id)
            }
        }

        query.addColumn('date', {level: 'month'})
        query.addColumn('quantity', {aggregation: 'sum'})
        query.addColumn('turnover', {aggregation: 'sum'})

        return await CumulioAPI.query(query)
    }

    getAchievedBarChartData(perMonthData: PerMonthData, achievedKey: string, targetKey: string): AchievedBarChartData {
        const data = {}

        Object.keys(perMonthData).forEach(month => {
            data[month] = {
                achieved: perMonthData[month][achievedKey],
                target: perMonthData[month][targetKey],
            }
        })

        return data
    }

    getAchievedDoughnutChartData(perMonthData: PerMonthData, achievedKey: string, targetKey: string): AchievedDoughnutChartData {
        const data = {
            achieved: 0,
            target: 0,
        }

        Object.keys(perMonthData).forEach(month => {
            data.achieved += perMonthData[month][achievedKey]
            data.target += perMonthData[month][targetKey]
        })

        return data
    }

    @Watch('period')
    @Watch('branch')
    async loadSalesPerUserData(): Promise<void> {
        this.loadingSalesPerUserData = true
        this.salesPerUserData = await this.loadPerUserData('sale')
        this.loadingSalesPerUserData = false
    }

    @Watch('period')
    @Watch('branch')
    async loadMortgagePerUserData(): Promise<void> {
        this.loadingMortgagePerUserData = true
        this.mortgagePerUserData = await this.loadPerUserData('mortgage')
        this.loadingMortgagePerUserData = false
    }

    async loadPerUserData(type: string): Promise<PerSubjectData> {
        const perUserData = this.initPerUserData()

        // Load achieved quantity
        const achievedQuantityData = await this.loadAchievedQuantityPerUserData(type)
        for (const data of achievedQuantityData) {
            if (!perUserData[data.user_id]) {
                continue
            }

            perUserData[data.user_id].achievedQuantity = parseFloat(data.quantity as string)
            perUserData[data.user_id].involvedQuantity = parseFloat(data.involved_quantity as string)
        }

        // Load achieved turnover
        const achievedTurnoverData = await this.loadAchievedTurnoverPerUserData(type)
        for (const data of achievedTurnoverData) {
            if (!perUserData[data.user_id]) {
                continue
            }

            perUserData[data.user_id].achievedTurnover = parseFloat(data.turnover as string)
        }

        return perUserData
    }

    initPerUserData(): PerSubjectData {
        const perUserData: PerSubjectData = {}

        this.$currentCompany.getAvailableUsers({ branch: this.branch }).forEach((user: User) => {
            perUserData[user.id] = {
                subject: user,
                achievedQuantity: null,
                involvedQuantity: null,
                achievedTurnover: null,
            }
        })

        return perUserData
    }

    async loadAchievedQuantityPerUserData(type: string): Promise<CumulioResult[]> {
        const query = this.initQuery('achieved_quantity', type)
        query.addColumn('user_id')
        query.addColumn('quantity', { aggregation: 'sum' })
        query.addColumn('involved_quantity', { aggregation: 'sum' })
        query.addFilter('direction', '=', this.directionForType(type))
        query.addFilter('user_id', 'is not null')

        if (this.branch) {
            query.addFilter('team_id', '=', this.branch.id)
        }

        return await CumulioAPI.query(query)
    }

    async loadAchievedTurnoverPerUserData(type: string): Promise<CumulioResult[]> {
        const query = this.initQuery('achieved_turnover', type)
        query.addColumn('user_id')
        query.addColumn('turnover', { aggregation: 'sum' })
        query.addFilter('user_id', 'is not null')

        if (this.branch) {
            query.addFilter('team_id', '=', this.branch.id)
        }

        return await CumulioAPI.query(query)
    }

    get totalPerUserData(): PerSubjectData {
        const totalPerUserData = this.initPerUserData()

        Object.keys(this.salesPerUserData).forEach(userId => {
            totalPerUserData[userId].achievedQuantity += this.salesPerUserData[userId].achievedQuantity
            totalPerUserData[userId].involvedQuantity += this.salesPerUserData[userId].involvedQuantity
            totalPerUserData[userId].achievedTurnover += this.salesPerUserData[userId].achievedTurnover
        })

        Object.keys(this.mortgagePerUserData).forEach(userId => {
            totalPerUserData[userId].achievedQuantity += this.mortgagePerUserData[userId].achievedQuantity
            totalPerUserData[userId].involvedQuantity += this.mortgagePerUserData[userId].involvedQuantity
            totalPerUserData[userId].achievedTurnover += this.mortgagePerUserData[userId].achievedTurnover
        })

        return totalPerUserData
    }

    getPerUserTableData(perUserData: PerSubjectData, key: string): PerSubjectTableData {
        const data = {}

        Object.keys(perUserData).forEach(userId => {
            if (!this.hasPerUserData(userId)) {
                return
            }

            data[userId] = {
                subject: perUserData[userId].subject,
                value: perUserData[userId][key],
            }
        })

        return data
    }

    getPerUserOverviewTableData(): PerSubjectOverviewTableData {
        const data = {}

        Object.keys(this.salesPerUserData).forEach(userId => {
            if (!this.hasPerUserData(userId)) {
                return
            }

            if (!data[userId]) {
                data[userId] = {
                    subject: this.salesPerUserData[userId].subject,
                    achievedSalesQuantity: null,
                    involvedSalesQuantity: null,
                    achievedSalesTurnover: null,
                    achievedMortgageQuantity: null,
                    involvedMortgageQuantity: null,
                    achievedMortgageTurnover: null,
                }
            }

            data[userId].achievedSalesQuantity += this.salesPerUserData[userId].achievedQuantity
            data[userId].involvedSalesQuantity += this.salesPerUserData[userId].involvedQuantity
            data[userId].achievedSalesTurnover += this.salesPerUserData[userId].achievedTurnover
        })

        Object.keys(this.mortgagePerUserData).forEach(userId => {
            if (!this.hasPerUserData(userId)) {
                return
            }

            if (!data[userId]) {
                data[userId] = {
                    subject: this.mortgagePerUserData[userId].subject,
                    achievedSalesQuantity: null,
                    involvedSalesQuantity: null,
                    achievedSalesTurnover: null,
                    achievedMortgageQuantity: null,
                    involvedMortgageQuantity: null,
                    achievedMortgageTurnover: null,
                }
            }

            data[userId].achievedMortgageQuantity += this.mortgagePerUserData[userId].achievedQuantity
            data[userId].involvedMortgageQuantity += this.mortgagePerUserData[userId].involvedQuantity
            data[userId].achievedMortgageTurnover += this.mortgagePerUserData[userId].achievedTurnover
        })

        return data
    }

    hasPerUserData(userId: string): boolean {
        const datasets = [
            this.salesPerUserData,
            this.mortgagePerUserData,
        ]

        for (const dataset of datasets) {
            if (!dataset[userId]) {
                continue
            }

            if (dataset[userId].achievedQuantity !== null) {
                return true
            }

            if (dataset[userId].involvedQuantity !== null) {
                return true
            }

            if (dataset[userId].achievedTurnover !== null) {
                return true
            }
        }

        return false
    }

    async loadSalesPerBranchData(): Promise<void> {
        this.loadingSalesPerBranchData = true
        this.salesPerBranchData = await this.loadPerBranchData('sale')
        this.loadingSalesPerBranchData = false
    }

    async loadMortgagePerBranchData(): Promise<void> {
        this.loadingMortgagePerBranchData = true
        this.mortgagePerBranchData = await this.loadPerBranchData('mortgage')
        this.loadingMortgagePerBranchData = false
    }

    async loadPerBranchData(type: string): Promise<PerSubjectData> {
        const perBranchData = this.initPerBranchData()

        // Load achieved quantity
        const achievedQuantityData = await this.loadAchievedQuantityPerBranchData(type)
        for (const data of achievedQuantityData) {
            if (!perBranchData[data.team_id]) {
                continue
            }

            perBranchData[data.team_id].achievedQuantity = parseFloat(data.quantity as string)
            perBranchData[data.team_id].involvedQuantity = parseFloat(data.involved_quantity as string)
        }

        // Load achieved turnover
        const achievedTurnoverData = await this.loadAchievedTurnoverPerBranchData(type)
        for (const data of achievedTurnoverData) {
            if (!perBranchData[data.team_id]) {
                continue
            }

            perBranchData[data.team_id].achievedTurnover = parseFloat(data.turnover as string)
        }

        return perBranchData
    }

    initPerBranchData(): PerSubjectData {
        const perBranchData: PerSubjectData = {}

        this.$currentCompany.getAvailableBranches().forEach((branch: Branch) => {
            perBranchData[branch.id] = {
                subject: branch,
                achievedQuantity: null,
                involvedQuantity: null,
                achievedTurnover: null,
            }
        })

        return perBranchData
    }

    async loadAchievedQuantityPerBranchData(type: string): Promise<CumulioResult[]> {
        const query = this.initQuery('achieved_quantity', type)
        query.addColumn('team_id')
        query.addColumn('quantity', { aggregation: 'sum' })
        query.addColumn('involved_quantity', { aggregation: 'sum' })
        query.addFilter('direction', '=', this.directionForType(type))
        query.addFilter('team_id', 'is not null')

        return await CumulioAPI.query(query)
    }

    async loadAchievedTurnoverPerBranchData(type: string): Promise<CumulioResult[]> {
        const query = this.initQuery('achieved_turnover', type)
        query.addColumn('team_id')
        query.addColumn('turnover', { aggregation: 'sum' })
        query.addFilter('team_id', 'is not null')

        return await CumulioAPI.query(query)
    }

    get totalPerBranchData(): PerSubjectData {
        const totalPerBranchData = this.initPerBranchData()

        Object.keys(this.salesPerBranchData).forEach(branchId => {
            totalPerBranchData[branchId].achievedQuantity += this.salesPerBranchData[branchId].achievedQuantity
            totalPerBranchData[branchId].involvedQuantity += this.salesPerBranchData[branchId].involvedQuantity
            totalPerBranchData[branchId].achievedTurnover += this.salesPerBranchData[branchId].achievedTurnover
        })

        Object.keys(this.mortgagePerBranchData).forEach(branchId => {
            totalPerBranchData[branchId].achievedQuantity += this.mortgagePerBranchData[branchId].achievedQuantity
            totalPerBranchData[branchId].involvedQuantity += this.mortgagePerBranchData[branchId].involvedQuantity
            totalPerBranchData[branchId].achievedTurnover += this.mortgagePerBranchData[branchId].achievedTurnover
        })

        return totalPerBranchData
    }

    getPerBranchOverviewTableData(): PerSubjectOverviewTableData {
        const data = {}

        Object.keys(this.salesPerBranchData).forEach(branchId => {
            if (!this.hasPerBranchData(branchId)) {
                return
            }

            if (!data[branchId]) {
                data[branchId] = {
                    subject: this.salesPerBranchData[branchId].subject,
                    achievedSalesQuantity: null,
                    involvedSalesQuantity: null,
                    achievedSalesTurnover: null,
                    achievedMortgageQuantity: null,
                    involvedMortgageQuantity: null,
                    achievedMortgageTurnover: null,
                }
            }

            data[branchId].achievedSalesQuantity += this.salesPerBranchData[branchId].achievedQuantity
            data[branchId].involvedSalesQuantity += this.salesPerBranchData[branchId].involvedQuantity
            data[branchId].achievedSalesTurnover += this.salesPerBranchData[branchId].achievedTurnover
        })

        Object.keys(this.mortgagePerBranchData).forEach(branchId => {
            if (!this.hasPerBranchData(branchId)) {
                return
            }

            if (!data[branchId]) {
                data[branchId] = {
                    subject: this.mortgagePerBranchData[branchId].subject,
                    achievedSalesQuantity: null,
                    involvedSalesQuantity: null,
                    achievedSalesTurnover: null,
                    achievedMortgageQuantity: null,
                    involvedMortgageQuantity: null,
                    achievedMortgageTurnover: null,
                }
            }

            data[branchId].achievedMortgageQuantity += this.mortgagePerBranchData[branchId].achievedQuantity
            data[branchId].involvedMortgageQuantity += this.mortgagePerBranchData[branchId].involvedQuantity
            data[branchId].achievedMortgageTurnover += this.mortgagePerBranchData[branchId].achievedTurnover
        })

        return data
    }

    hasPerBranchData(branchId: string): boolean {
        const datasets = [
            this.salesPerBranchData,
            this.mortgagePerBranchData,
        ]

        for (const dataset of datasets) {
            if (!dataset[branchId]) {
                continue
            }

            if (dataset[branchId].achievedQuantity !== null) {
                return true
            }

            if (dataset[branchId].involvedQuantity !== null) {
                return true
            }

            if (dataset[branchId].achievedTurnover !== null) {
                return true
            }
        }

        return false
    }

    getPerUserPieChartData(): PerSubjectPieChartData {
        const data = {}

        Object.keys(this.salesPerUserData).forEach(userId => {
            if (!data[userId]) {
                data[userId] = {
                    subject: this.salesPerUserData[userId].subject,
                    value: null,
                }
            }

            data[userId].value += this.salesPerUserData[userId].achievedTurnover
        })

        Object.keys(this.mortgagePerUserData).forEach(userId => {
            if (!data[userId]) {
                data[userId] = {
                    subject: this.mortgagePerUserData[userId].subject,
                    value: null,
                }
            }

            data[userId].value += this.mortgagePerUserData[userId].achievedTurnover
        })

        return data
    }

    getPerBranchPieChartData(): PerSubjectPieChartData {
        const data = {}

        Object.keys(this.salesPerBranchData).forEach(branchId => {
            if (!data[branchId]) {
                data[branchId] = {
                    subject: this.salesPerBranchData[branchId].subject,
                    value: null,
                }
            }

            data[branchId].value += this.salesPerBranchData[branchId].achievedTurnover
        })

        Object.keys(this.mortgagePerBranchData).forEach(branchId => {
            if (!data[branchId]) {
                data[branchId] = {
                    subject: this.mortgagePerBranchData[branchId].subject,
                    value: null,
                }
            }

            data[branchId].value += this.mortgagePerBranchData[branchId].achievedTurnover
        })

        return data
    }

    formatQuantity(quantity: number): string {
        return (quantity || 0).toLocaleString('nl', { maximumFractionDigits: 0 })
    }

    formatTurnover(turnover: number, precision: number = 2): string {
        return (turnover || 0).toLocaleString('nl', { maximumFractionDigits: precision, style: 'currency', currency: 'EUR' })
    }

    initQuery(id: string, type: string, branchColumnId: string = 'team_id', userColumnId: string = 'user_id'): CumulioQuery {
        const query = new CumulioQuery(id, this.$currentUser)

        // Add date filter
        query.addFilter('date', '>=', moment(this.fromDate).tz('Zulu').format())
        query.addFilter('date', '<=', moment(this.untilDate).tz('Zulu').format())

        // Add type filter
        if (this.isOrderTypeEnabled(type)) {
            query.addFilter('order_type', '=', type)
        } else {
            query.addFilter('referral_type', '=', type)
        }

        // Add branch security filter
        if (branchColumnId) {
            query.addBranchesFilter(branchColumnId, this.$currentCompany.branches)
        }

        // Add user security filter (if not added a branch security filter already)
        if (userColumnId && !branchColumnId) {
            query.addUsersFilter(userColumnId, this.$currentCompany.users)
        }

        return query
    }
}
